/**
 * Implements a content route interceptor as a behavior. It manages tabular
 * reports requested from main menu.
 *
 * It must attached to the main layout.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import MainScreenReport from "../views/report/main-screen";

const channel = Radio.channel("global");

class Content extends Marionette.Behavior {
  initialize() {
    this.listenTo(channel, "home", this.onHomeReport);
    this.listenTo(channel, "drilldown", this.onDrilldownReport);
    this.listenTo(channel, "admin.accounts", this.onHomeReport);
    this.listenTo(channel, "admin.event-history", this.onHomeReport);
    this.listenTo(channel, "admin.config-settings", this.onHomeReport);
    this.listenTo(channel, "tools.user-report", this.onHomeReport);
    this.listenTo(channel, "tools.hcc-disease-hierarchies", this.onHomeReport);
    this.listenTo(channel, "tools.diagnosis-codes", this.onHomeReport);
    this.listenTo(channel, "tools.procedure-codes", this.onHomeReport);
    this.listenTo(channel, "tools.national-drug-codes", this.onHomeReport);
  }

  // handles main screen reports
  onHomeReport(route) {
    this.view.content.show(
      new MainScreenReport({
        model: route,
      })
    );
  }

  onDrilldownReport(route) {
    channel.trigger("drilldown:report", route);
  }
}

export { Content as default };
